import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewContainerRef
} from '@angular/core';
import * as Cesium from 'cesium';
import {DataService} from '../data.service';
import {interval, Observable, Subscription} from 'rxjs';
import {LatLonModel, ParameterSettingModel, SettingConfig} from '../type-class';
import * as moment from 'moment';
import {Papa} from 'ngx-papaparse';
import {environment} from '../../environments/environment';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {flatMap} from 'rxjs/operators';
import {MatTabGroup} from '@angular/material/tabs';
import {InfoCesiumBtnComponent} from '../info-cesium-btn/info-cesium-btn.component';
import {DisclaimerBtnComponent} from '../disclaimer-btn/disclaimer-btn.component';


@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.css']
})
export class ViewerComponent implements OnInit, AfterViewInit, OnDestroy {

  private componentInstance: ComponentRef<InfoCesiumBtnComponent> = null;
  private componentInstanceDisclaimer: ComponentRef<DisclaimerBtnComponent> = null;

  private viewer: Cesium.Viewer;
  private globe: any;
  private scene: Cesium.Scene;
  private camera: Cesium.Camera;
  private layerListCollection: Cesium.ImageryLayerCollection;
  private currentLayerList: any[] = [];

  private $data: Observable<SettingConfig>;
  public settingsData: SettingConfig;
  public parameterList: ParameterSettingModel[] = [];
  public selectedParameter: ParameterSettingModel;
  private currentImgLayer: Cesium.ImageryLayer;

  public layerOpacity = 0.7;

  public currentTime: moment.Moment;
  public selectedTime: string;
  public legendUrl: string;
  public currentTimeRange: string[];
  private currentParamSetting: ParameterSettingModel;
  private idxOfTime: number;


  private mouseMoved = false;
  public loadingGlobe = false;


  private chartOptions$: Observable<any>;
  public chartOptions: any;
  private chartData: { data: any[]; parameter: string; };
  private customDataSourceCollection: any;
  private markerDataSource: Cesium.CustomDataSource;
  private tmpCoords: LatLonModel;
  private fixDecimal = 5;


  public showLegend = true;
  public isSmallScreen: boolean;
  public showToolbar = true;

  private checkInterval: Subscription;
  private dataSubscribe: Subscription;
  hideTabContent = true;

  private worldTerrainProvider: any;
  flyToList: {
    name: string;
    value: string;
    flyOption: any
  }[] = [
    {
      name: 'Europe', value: 'europe', flyOption:
        {
          destination: Cesium.Rectangle.fromDegrees(-60, 30, 90, 90)
        }
    },
    {
      name: 'Mont Blanc', value: 'mont-blanc', flyOption:
        {
          destination: {x: 4442097.626939743, y: 532358.0031872004, z: 4542048.747280682},
          orientation: {
            position: {
              longitude: 0.11927497239456124,
              latitude: 0.796312087326827,
              height: 8153.1483916634525
            },
            heading: 0.052365244077769546, pitch: -0.2867768537776616, roll: 0.00018342047974861941
          }
        }
    },
    {
      name: 'Matterhorn', value: 'matterhorn', flyOption: {
        destination: {x: 4396104.437266731, y: 603113.9411425105, z: 4571578.807541274},
        orientation: {
          position: {
            longitude: 0.13634166458739058, latitude: 0.8036587044541126, height: 3835.9920399895605
          },
          heading: 4.0324683066564,
          pitch: -0.11047650230791639,
          roll: 6.280559747491118
        }
      }
    }
  ];
  public tablet: boolean;


  constructor(private el: ElementRef,
              private dataService: DataService,
              private papa: Papa,
              private breakpointObserver: BreakpointObserver,
              private viewContainerRef: ViewContainerRef,
              private componentFactoryResolver: ComponentFactoryResolver
  ) {
    // get an error on npm run test when this line isn't
    // @ts-ignore
    window.CESIUM_BASE_URL = 'assets/cesium';
  }

  // cesium-viewer-cesiumWidgetContainer


  ngOnInit() {
    this.createLoaderComponent();

    this.setCesiumToken();
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    this.tablet = this.breakpointObserver.isMatched([Breakpoints.Tablet]);
    // console.log('isSmallScreen: ', this.isSmallScreen);
    this.showToolbar = !this.isSmallScreen;
    this.showLegend = !this.isSmallScreen;

    const groundLayer = new Cesium.UrlTemplateImageryProvider({
      url: 'https://api.maptiler.com/tiles/satellite/{z}/{x}/{y}.jpg?key=' + environment.maptilerKey,
      tileWidth: 256,
      tileHeight: 256,
      credit: new Cesium.Credit('<a href="https://www.maptiler.com" target="_blank"><img title="Maptiler" src="./assets/maptiler-logo-white.png"></a>', true)
    });

    const emptyTile =  new Cesium.SingleTileImageryProvider({
      url: './assets/_.png',
      credit: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
    });




    function CustomeOpenCageGeocoderService() {
    }

    CustomeOpenCageGeocoderService.prototype.geocode = (input) => {
      const endpoint = 'https://cdn.meteomatics.swiss/geocoder/en/';

      const resource = new Cesium.Resource({
        url: endpoint + input,
      });

      return resource.fetchJson()
        .then((results) => {
          let bboxDegrees;
          const resultArr = (results.length) ? results : [];
          // console.log(results);
          return resultArr.map((resultObject) => {
            bboxDegrees = resultObject.bbox;
            let destRect;
            if (!bboxDegrees) {
              destRect = Cesium.Cartesian3.fromDegrees(resultObject.location.lon, resultObject.location.lat, 15000.0);
            } else {
              destRect = Cesium.Rectangle.fromDegrees(
                bboxDegrees.west,
                bboxDegrees.south,
                bboxDegrees.east,
                bboxDegrees.north
              );
            }

            return {
              displayName: resultObject.name,
              destination: destRect
            };
          });
        });

    };


    this.currentTime = moment.utc().minute(0).seconds(0).milliseconds(0);
    this.customDataSourceCollection = new Cesium.DataSourceCollection();
    Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(-60, -30, 90, 90);
    // Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;
    // this.viewer = new Cesium.Viewer(this.el.nativeElement);
    this.worldTerrainProvider = Cesium.createWorldTerrain();

    // start with 3D
    this.viewer = new Cesium.Viewer(this.el.nativeElement, {
      timeline: false,
      homeButton: true,
      baseLayerPicker: false,
      terrainProvider: this.worldTerrainProvider, // terrainProvider: new EllipsoidTerrainProvider()
      sceneModePicker: true,
      imageryProvider: groundLayer,
      dataSources: this.customDataSourceCollection,
      infoBox: false,
      geocoder: new CustomeOpenCageGeocoderService(),
      animation: false,
      requestRenderMode: true,
    });
    this.scene = this.viewer.scene;
    this.globe = this.scene.globe;
    this.globe.enableLighting = false;
    this.globe.showGroundAtmosphere = false;
    this.camera = this.viewer.scene.camera;
    this.layerListCollection = this.viewer.imageryLayers;

    // this.viewer.scene.screenSpaceCameraController.enableZoom = false;
    this.viewer.imageryLayers.addImageryProvider(emptyTile);

    this.markerDataSource = new Cesium.CustomDataSource('chart-point');
    this.customDataSourceCollection.add(this.markerDataSource);

    // this.scene.globe.showGroundAtmosphere = false;
    this.$data = this.dataService.getSettings();
    this.chartOptions$ = this.dataService.chartOptions$;

    this.setEventHandler();


    this.chartOptions$.subscribe((value) => {
      console.log('chartOptions', value);
      this.chartOptions = value;

      if (!value) {
        this.tmpCoords = null;
        const dataSourceList = this.customDataSourceCollection;
        // @ts-ignore
        const dataSourceTmp = dataSourceList.getByName('chart-point')[0];
        if (dataSourceTmp) {
          dataSourceTmp.entities.removeAll();
        }
      }
      this.viewer.scene.requestRender();
    });


    this.subscribeSetting();


  }

  ngAfterViewInit(): void {
    this.createExtraHelpButtonCesiumToolbar();
    this.createDisclamerButtonCesiumCredits();
  }

  filterList(list: string[], elementsToRemoveList: string[]) {
    return list.filter((el) => {
      return !elementsToRemoveList.includes(el);
    });
  }

  private setCesiumToken() {
    Cesium.Ion.defaultAccessToken = environment.cesium_ion_token;
  }


  changeParameterList() {
    this.parameterList = this.settingsData.layers;
    this.selectedParameter = this.parameterList.find((layer) => {
      return layer.name === this.settingsData.default_layer;
    });

    this.selectedParameter = this.selectedParameter ? this.selectedParameter : this.parameterList[0];
  }

  changeParameter(value) {
    this.selectedParameter = value;
    this.prepareLayers(true);
    // this.updateLayer(true);
  }

  changeAlpha(opactiy: any) {
    this.layerOpacity = opactiy;
    this.currentImgLayer.alpha = opactiy; // this.layerTest.opacity;
    this.scene.requestRender();
  }

  createNewImagerLayer(show: boolean, time) {

    const parameter = this.currentParamSetting;
    const urlProvider = this.currentParamSetting.tile_url;
    const defaultTime = time;

    const ownCredit = '<a href="https://api.meteomatics.com" target="_blank">Meteomatics Weather Layer</a> ' +
      '  based on data by ECMWF, NOAA, UKMO, DWD, CMC, KNMI, FMI, MeteoFrance, MeteoSwiss, NASA, EUMETSAT and SLF';

    const rectangle = Cesium.Rectangle.fromDegrees(this.currentParamSetting.bbox.west,
      this.currentParamSetting.bbox.south, this.currentParamSetting.bbox.east, this.currentParamSetting.bbox.north);
    const tilingScheme = new Cesium.GeographicTilingScheme({
      ellipsoid: Cesium.Ellipsoid.WGS84,
      rectangle,
      numberOfLevelZeroTilesX: 1,
      numberOfLevelZeroTilesY: 1
    });

    const layerProvider = new Cesium.UrlTemplateImageryProvider({
      url: urlProvider,
      customTags: {
        timestamp: (imageryProvider, x, y, level) => {
          return defaultTime;
        }
      },
      rectangle,
      tilingScheme,
      credit: ownCredit,
      maximumLevel: this.settingsData.max_zoom,
      // minimumLevel: 4
      tileWidth: this.settingsData.resolution,
      tileHeight: this.settingsData.resolution,
      subdomains: ['01', '02', '03', '04', '05', '06']
    });

    return new Cesium.ImageryLayer(layerProvider, {show, alpha: this.layerOpacity});
  }


  private createLayerList(currentTimeRange: string[]) {
    const layers = [];
    for (const time of currentTimeRange) {
      const showLayer = this.selectedTime === time;
      const layer = this.createNewImagerLayer(showLayer, time);
      layers.push(layer);
      if (showLayer) {
        this.currentImgLayer = layer;
      }
      this.layerListCollection.add(layer);

    }
    return layers;
  }

  private rmAllLayers() {
    for (const layer of this.currentLayerList) {
      this.layerListCollection.remove(layer, true);
    }
    this.currentLayerList = [];
    // console.log(this.currentLayerList);

  }

  private prepareLayers(updateChart = false) {
    if (this.selectedParameter) {
      this.currentParamSetting = this.selectedParameter;
      this.currentTimeRange = this.currentParamSetting.timestamps;
      this.legendUrl = environment.api_scheme_host + this.currentParamSetting.legend_url;

      if (this.currentTimeRange.indexOf(this.selectedTime) > -1) {
        this.idxOfTime = this.currentTimeRange.indexOf(this.selectedTime);
      } else {
        this.selectedTime = this.currentParamSetting.default_timestamp;
        this.idxOfTime = this.currentTimeRange.indexOf(this.selectedTime);
      }


      if (this.currentLayerList.length) {
        this.rmAllLayers();
      }
      this.currentLayerList = this.createLayerList(this.currentTimeRange);

      if (updateChart && this.tmpCoords) {
        this.createChartInfo(this.tmpCoords);
      }

    } else {
      this.currentParamSetting = null;
      this.dataService.setChartOptions(null);
      console.log('no parameter for this model');
    }

  }

  private updateShowLayer() {
    this.idxOfTime = this.currentTimeRange.indexOf(this.selectedTime);
    // console.log('Idx :', this.idxOfTime);
    this.currentLayerList[this.idxOfTime].alpha = this.layerOpacity;
    this.currentLayerList[this.idxOfTime].show = true;
    this.currentImgLayer.show = false;
    this.currentImgLayer = this.currentLayerList[this.idxOfTime];
  }


  setTime(newTime: string) {
    if (newTime) {
      this.selectedTime = newTime;

      this.viewer.clock.currentTime = Cesium.JulianDate.fromIso8601(this.selectedTime);
    } else {
      console.log('no time found, set current time');
      this.selectedTime = this.currentTime.format();
    }
  }


  timeForth() {
    this.setTime(moment.utc(this.selectedTime).add(1, 'h').format());

    if (this.currentTimeRange.indexOf(this.selectedTime) > -1) {

    } else {
      this.setTime(this.currentTimeRange[0]);
    }
    this.updateShowLayer();
    // this.updateLayer();
  }

  timeBack() {
    this.setTime(moment.utc(this.selectedTime).subtract(1, 'h').format());
    if (this.currentTimeRange.indexOf(this.selectedTime) > -1) {

    } else {
      this.setTime(
        this.currentTimeRange[
        this.currentTimeRange.length - 1
          ]);
    }
    this.updateShowLayer();
    // this.updateLayer();
  }

  changeTime($event: any) {
    this.idxOfTime = $event;
    if (this.currentTimeRange[this.idxOfTime]) {
      this.setTime(this.currentTimeRange[this.idxOfTime]);
    } else {
      console.log('No time in TimeRange');
    }
    this.updateShowLayer();
    // this.updateLayer();

  }

  private setEventHandler() {
    const that = this;


    const handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);


    if (this.isSmallScreen || this.tablet) {

      handler.setInputAction((movement) => {
        that.scene.camera.cancelFlight();
        that.createChartIfCartesian(movement);
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
      //
      // handler.setInputAction((movement) => {
      //   that.mouseMoved = false;
      // }, Cesium.ScreenSpaceEventType.PINCH_START);

    } else {


      handler.setInputAction((movement) => {
        that.mouseMoved = false;
        that.scene.camera.cancelFlight();
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
      handler.setInputAction((movement) => {
        if (that.mouseMoved) {
          // console.log('moved');
        } else {
          // console.log('not moved');
          that.createChartIfCartesian(movement);
        }
      }, Cesium.ScreenSpaceEventType.LEFT_UP);
      handler.setInputAction((movement) => {
        that.mouseMoved = true;
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    }
    this.scene.morphStart.addEventListener(() => {
      console.log(that.globe.ellipsoid);
      if (that.scene.mode === 2) {
        // console.log('add Terrain');
        that.viewer.terrainProvider = that.worldTerrainProvider;
      } else {
        // console.log('remove Terrain');
        that.viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
      }

    });


    const helper = new Cesium.EventHelper();
    helper.add(this.globe.tileLoadProgressEvent, (event) => {
      // console.log("Tiles to load: " + event);
      that.loadingGlobe = event !== 0;
    });


  }

  createChartIfCartesian(movement) {
    const cartesian = this.viewer.camera.pickEllipsoid(movement.position, this.viewer.scene.globe.ellipsoid);
    if (cartesian) {
      // console.log('globe picked');
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      const longitudeString = Cesium.Math.toDegrees(cartographic.longitude).toFixed(this.fixDecimal);
      const latitudeString = Cesium.Math.toDegrees(cartographic.latitude).toFixed(this.fixDecimal);

      this.tmpCoords = this.setLatLonObj(Number(longitudeString), Number(latitudeString));

      this.createChartInfo(this.tmpCoords);
    } else {
      // console.log('globe is not picked');
    }
  }

  setLatLonObj(lon: number, lat: number): LatLonModel {

    return {lon, lat};
  }

  createChartInfo(latLon: LatLonModel) {


    if (this.currentParamSetting) {
      const tmpMarkerCoords = latLon;
      let tmpPlotUrl = this.currentParamSetting.plot_url;
      if (tmpPlotUrl) {
        const tmpParameter = this.selectedParameter.name;
        tmpPlotUrl = tmpPlotUrl.replace('{lon}', tmpMarkerCoords.lon.toString());
        tmpPlotUrl = tmpPlotUrl.replace('{lat}', tmpMarkerCoords.lat.toString());
        tmpPlotUrl = tmpPlotUrl.replace('{format}', 'csv');


        this.updateChartPointMarker(tmpMarkerCoords);
        // this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(environment.api_scheme_host + tmpPlotUrl);
        this.dataService.getPlot(tmpPlotUrl).subscribe((data) => {
          // console.log('createChart', data);
          const parsedCSV = this.papa.parse(data,
            {
              skipEmptyLines: true
            });
          const dataArr = parsedCSV.data.map((point) => {
            return [new Date(point[0]).getTime(), point[1]];
          });
          this.chartData = {
            parameter: tmpParameter,
            data: dataArr.slice(1).map((point) => {
              return [point[0], Number(point[1])];
            })

          };
          const coords = tmpMarkerCoords;
          const name = this.chartData.parameter;

          const staticOptions = {
            chart: {
              height: 400
            },
            title: {
              text: 'Lon:' + coords.lon + ' Lat:' + coords.lat
            },
            credits: {
              enabled: false
            },
            legend: {
              enabled: false
            },
            tooltip: {
              shared: true
            },
            xAxis: {
              type: 'datetime',
              title: {
                text: 'Date'
              },
              minorTickInterval: 1000 * 60 * 60 * 6,
              tickInterval: 1000 * 60 * 60 * 3,
              dateTimeLabelFormats: {
                day: '%Y-%m-%d , %H:%M',
              },
              crosshair: true
            },
            yAxis: {
              title: {
                text: name,
              }
            },
            series: []
          };

          staticOptions.series = [{
            name: this.chartData.parameter,
            type: 'spline',
            data: this.chartData.data
          }];


          this.dataService.setChartOptions(staticOptions);
        }, (error) => {
          console.log('no chart', error);
          this.dataService.setChartOptions(null);
          // this.data = this.sanitizer.bypassSecurityTrustHtml(error.error.text);
        });
      } else {
        console.log('no chart for this parameter', this.currentParamSetting);
        this.dataService.setChartOptions(null);
      }


    } else {
      console.log('no currentParamSetting');
    }


  }

  private updateChartPointMarker(latLonObj: LatLonModel) {
    const dataSourceTmp = this.customDataSourceCollection.getByName('chart-point')[0];
    if (dataSourceTmp) {
      dataSourceTmp.entities.removeAll();
    }

    dataSourceTmp.entities.add({
      position: Cesium.Cartesian3.fromDegrees(latLonObj.lon, latLonObj.lat),
      point: {
        color: Cesium.Color.SKYBLUE, // default: WHITE
        pixelSize: 10, // default: 1
      }
    });
  }


  private startCheckVersion() {
    if (this.checkInterval) {
      this.checkInterval.unsubscribe();
    }

    this.checkInterval = interval(2 * 60 * 1000)
      .pipe(
        flatMap(() => this.dataService.checkVersion())
      ).subscribe(data => {
        // console.log('check hash with old on', data);

        if (data.hash !== this.settingsData.hash) {
          // console.log('update');
          this.subscribeSetting();
        }

      });
  }

  private subscribeSetting() {
    if (this.dataSubscribe) {
      this.dataSubscribe.unsubscribe();
    }

    this.dataSubscribe = this.$data.subscribe((data) => {
      this.settingsData = data;

      this.changeParameterList();

      this.prepareLayers(); // and show
      // this.updateLayer();

      this.startCheckVersion();
    }, (error) => {
      console.log(error);

      // TODO: Dialog parameter changed / time expired

    });
  }

  ngOnDestroy(): void {
    if (this.checkInterval) {
      this.checkInterval.unsubscribe();
    }
    if (this.dataSubscribe) {
      this.dataSubscribe.unsubscribe();
    }

  }

  showOnlyHeaders(tabGroupMobile: MatTabGroup) {
    if (this.hideTabContent === false) {
      tabGroupMobile.selectedIndex = -1;
    }

    this.hideTabContent = !this.hideTabContent;
  }


  private createLoaderComponent() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(InfoCesiumBtnComponent);
    this.componentInstance = this.viewContainerRef.createComponent(componentFactory);

    const componentFactoryDisclaimer = this.componentFactoryResolver.resolveComponentFactory(DisclaimerBtnComponent);
    this.componentInstanceDisclaimer = this.viewContainerRef.createComponent(componentFactoryDisclaimer);
  }

  private createExtraHelpButtonCesiumToolbar() {
    const cesiumToolbar = this.el.nativeElement.querySelector('.cesium-viewer-toolbar');

    const loaderComponentElement = this.componentInstance.location.nativeElement;
    const sibling: HTMLElement = cesiumToolbar; // .lastElementChild;
    // cesiumToolbar[0].lastElementChild.insertBefore(this.componentInstance);
    sibling.insertBefore(loaderComponentElement, sibling.lastChild);
    // console.log(cesiumToolbar);
  }

  private createDisclamerButtonCesiumCredits() {
    const cesiumCredits = this.el.nativeElement.querySelector('.cesium-widget-credits');

    const loaderComponentElement = this.componentInstanceDisclaimer.location.nativeElement;
    const sibling: HTMLElement = cesiumCredits; // .lastElementChild;
    // cesiumToolbar[0].lastElementChild.insertBefore(this.componentInstance);
    sibling.insertBefore(loaderComponentElement, sibling.lastChild);
    // console.log(cesiumToolbar);
  }


  demoFly() {
    const that = this;

    function flyThroughTheAlps(adjustPitch) {

      function createOption(lon, lat, height, duration, maxHeight, easingFunction) {
        return {
          destination: Cesium.Cartesian3.fromDegrees(lon, lat, height),
          orientation: {
            heading: Cesium.Math.toRadians(10.0),
            pitch: Cesium.Math.toRadians(-20.0),
            roll: 0.0
            // heading: 0,
            // pitch: -Cesium.Math.PI_OVER_TWO,//Cesium.Math.toRadians(-60),
            // roll: 0.0
          },
          complete: undefined,
          duration,
          maximumHeight: maxHeight,
          easingFunction
        };
      }

      // 3D
      const pos4 = createOption(5.75, 45.6, 10000, 10, 10000, null);
      const pos5 = createOption(5.75, 45.6, 10000, 100, 10000, null);
      // slower zoomin bit
      const pos6 = createOption(11.28, 45.93, 10000, 100, 10000, Cesium.EasingFunction.LINEAR_NONE);


      const camera = that.scene.camera;


      pos4.complete = () => {
        setTimeout(() => {
          camera.flyTo(pos5);
        }, 400);
      };
      pos5.complete = () => {
        setTimeout(() => {
          camera.flyTo(pos6);
        }, 500);
      };
      pos6.complete = () => {

      };

      camera.flyTo(pos4);
    }

    setTimeout(() => {
      flyThroughTheAlps(false);
    }, 300);

  }


  flyTo(value: string) {
    if (value === '0') {
      this.scene.camera.flyTo(this.flyToList[0].flyOption);
    } else if (value === '1') {
      this.scene.camera.flyTo(this.flyToList[1].flyOption);
    } else if (value === '2') {
      this.scene.camera.flyTo(this.flyToList[2].flyOption);
    } else if (value === '3') {
      this.demoFly();
    }
  }

  public formatDate(time: string, mFormat: string) {
    return moment(time).format(mFormat);
  }


}
